"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import Logo from "@/app/(components)/generics/Logo/Logo";
import { useBrand } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PageProps } from "@/app/types/common/PageProps";
import styles from "./TenantGate.module.css";

export default function TenantGate(props: PageProps) {
  const T = useT();
  const { params } = props;

  const tenant = useBrand();
  const hasBrandLogo = !!tenant?.logoUrl;

  return (
    <div className={styles.container}>
      <div className={styles.topLeftGradient}></div>
      <div className={styles.topRightGradient}></div>

      <div className={styles.content}>
        <div className={styles.logos}>
          {hasBrandLogo && (
            <>
              <Logo className={styles.logoItem} />
              <span className={styles.separator}>×</span>
            </>
          )}
          <Logo ignoreBrand={true} className={styles.logoItem} />
        </div>

        <Button
          min={false}
          params={params}
          isLink={false}
          type={ButtonType.PRIMARY}
          text={T(TKey.LOG_IN)}
          onClick={() => ModalStore.getState().openSignIn(params)}
        />
      </div>
    </div>
  );
}
